module.exports = __webpack_public_path__ + "img/qrcode.04b1e07b.jpg";